var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPriority = function SvgPriority(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 16,
    "data-width-40": 24,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m0-1.15a6.85 6.85 0 1 0 0-13.7 6.85 6.85 0 0 0 0 13.7",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.2 4.8a.8.8 0 0 1 1.6 0v3.6a.8.8 0 0 1-1.6 0zM8 10.15a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPriority);
export default ForwardRef;